import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const taTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'பெயர் (சிறிய எழுத்து, சிறப்பு எழுத்துகள் இல்லை)',
    add: 'சேர்',
    allowedFileTypes: 'அனுமதிக்கப்பட்ட கோப்பு வகைகள்',
    allowedFileTypesDescription:
      'அனுமதிக்கப்பட்ட கோப்பு வகைகளை கட்டுப்படுத்தவும் (எ.கா., படம்/*, பயன்பாடு/pdf). அனைத்து வகைகளையும் அனுமதிக்க காலியாக விடவும்.',
    allowMultipleFiles: 'பல கோப்புகளை அனுமதிக்கவும்',
    amountInCents: 'தொகை சென்ட்களில்',
    basePrice: 'அடிப்படை விலை',
    bcc: 'பி.சி.சி',
    brand: 'பிராண்ட்',
    cc: 'சிசி',
    checkboxPlural: 'தேர்வுப்பெட்டி புலங்கள்',
    checkboxSingular: 'தேர்வுப்பெட்டி',
    checkedByDefault: 'இயல்பாக சரிபார்க்கப்பட்டது',
    chooseConfirmationType:
      'அவர்கள் படிவத்தைச் சமர்ப்பித்த பிறகு பக்கத்தில் உள்ள செய்தியைக் காட்ட வேண்டுமா அல்லது வேறு பக்கத்திற்குத் திருப்பிவிட வேண்டுமா என்பதைத் தேர்வுசெய்யவும்.',
    condition: 'நிபந்தனை',
    confirmationMessage: 'உறுதிப்படுத்தல் செய்தி',
    confirmationType: 'உறுதிப்படுத்தல் வகை',
    countryPlural: 'நாட்டின் புலங்கள்',
    countrySingular: 'நாடு',
    creditCard: 'கடன் அட்டை',
    customURL: 'தனிப்பயன் URL',
    datePlural: 'தேதி புலங்கள்',
    dateSingular: 'தேதி',
    defaultValue: 'இயல்புநிலை மதிப்பு',
    divide: 'பிரிக்கவும்',
    documentToLinkTo: 'இணைக்க வேண்டிய ஆவணம்',
    doesNotEqual: 'சமமாக இல்லை',
    emailFrom: 'இருந்து மின்னஞ்சல்',
    emailPlural: 'மின்னஞ்சல் புலங்கள்',
    emailsDescription:
      'படிவம் சமர்ப்பிக்கும் போது தனிப்பயன் மின்னஞ்சல்களை அனுப்பவும். ஒரே மின்னஞ்சலை பல பெறுநர்களுக்கு அனுப்ப கமாவால் பிரிக்கப்பட்ட பட்டியல்களைப் பயன்படுத்தவும். இந்தப் படிவத்திலிருந்து ஒரு மதிப்பைக் குறிப்பிட, அந்த புலத்தின் பெயரை இரட்டை சுருள் அடைப்புக்குறிகளுடன் மடிக்கவும், அதாவது {{firstName}}. எல்லா தரவையும் வெளியிட வைல்டு கார்டு {{*}} மற்றும் மின்னஞ்சலில் அதை HTML அட்டவணையாக வடிவமைக்க {{*:table}} ஐப் பயன்படுத்தலாம்.',
    emailSingular: 'மின்னஞ்சல்',
    emailTo: 'மின்னஞ்சல் அனுப்பவும்',
    equals: 'சமம்',
    field: 'களம்',
    fields: 'வயல்வெளிகள்',
    fieldWidth: 'புல அகலம் (சதவீதம்)',
    hasAnyValue: 'ஏதேனும் மதிப்பு உள்ளது',
    internalLink: 'உள் இணைப்பு',
    label: 'லேபிள்',
    maxFileSize: 'அதிகபட்ச கோப்பு அளவு (பைட்டுகள்)',
    maxFileSizeDescription: 'பைட்டுகளில் அதிகபட்ச கோப்பு அளவு. வரம்பு இல்லாமல் காலியாக விடவும்.',
    message: 'செய்தி',
    messageDescription: 'இந்த மின்னஞ்சலில் அனுப்ப வேண்டிய செய்தியை உள்ளிடவும்.',
    messagePlural: 'செய்தித் தொகுதிகள்',
    messageSingular: 'செய்தி',
    mimeType: 'MIME வகை',
    mimeTypePlural: 'MIME வகைகள்',
    mimeTypeSingular: 'MIME வகை',
    multiply: 'பெருக்கவும்',
    numberPlural: 'எண் புலங்கள்',
    numberSingular: 'எண்',
    optionPlural: 'விருப்பங்கள்',
    optionSingular: 'விருப்பம்',
    paymentFieldPlural: 'பணம் செலுத்தும் புலங்கள்',
    paymentFieldSingular: 'பணம் செலுத்துதல்',
    paymentProcessor: 'பணம் செலுத்தும் செயலி',
    paymentStatus: 'நிலை',
    placeholder: 'ப்ளாஸ்ஹோல்டர்',
    priceConditions: 'விலை நிபந்தனைகள்',
    priceConditionsPlural: 'விலை நிபந்தனைகள்',
    priceConditionsSingular: 'விலை நிலை',
    radioOptions: 'ரேடியோ பண்பு விருப்பங்கள்',
    radioPlural: 'வானொலி புலங்கள்',
    radioSingular: 'வானொலி',
    redirect: 'வழிமாற்று',
    replyTo: 'பதில்',
    required: 'தேவை',
    selectOptions: 'விருப்பங்களைத் தேர்ந்தெடுக்கவும்',
    selectPlural: 'புலங்களைத் தேர்ந்தெடுக்கவும்',
    selectSingular: 'தேர்ந்தெடு',
    statePlural: 'மாநில புலங்கள்',
    stateSingular: 'மாநிலம்',
    staticValue: 'நிலையான மதிப்பு',
    subject: 'பொருள்',
    submitButton: 'சமர்ப்பி பட்டன் லேபிளை',
    subtract: 'கழிக்கவும்',
    textareaPlural: 'டெக்ஸ்டாரியா புலங்கள்',
    textareaSingular: 'டெக்ஸ்டாரியா',
    textPlural: 'உரை புலங்கள்',
    textSingular: 'உரை',
    title: 'தலைப்பு',
    token: 'டோக்கன்',
    uploadCollection: 'பதிவேற்ற சேகரிப்பு',
    uploadCollectionDescription:
      'கோப்புகளைச் சேமிக்க எந்தப் பதிவேற்றத் தொகுப்பைத் தேர்ந்தெடுக்கவும்',
    uploadFieldPlural: 'புலங்களைப் பதிவேற்றவும்',
    uploadFieldSingular: 'பதிவேற்றவும்',
    urlToRedirectTo: 'திசைதிருப்ப வேண்டிய URL',
    value: 'மதிப்பு',
    valueOfField: 'புலத்தின் மதிப்பு',
    valueType: 'மதிப்பு வகை',
  },
}

export const ta: PluginLanguage = {
  dateFNSKey: 'ta',
  translations: taTranslations,
}
